import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.336 4.295c-1.172 1.171-1.172 3.057-1.172 6.828V21.79c0 3.771 0 5.657 1.172 6.828s3.057 1.172 6.828 1.172h2.667c3.771 0 5.657 0 6.828-1.172s1.172-3.057 1.172-6.828V11.123c0-3.771 0-5.657-1.172-6.828s-3.057-1.172-6.828-1.172h-2.667c-3.771 0-5.657 0-6.828 1.172m3.161 18.828a1 1 0 0 1 1-1h4a1 1 0 0 1 0 2h-4a1 1 0 0 1-1-1m1-6.333a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2zm-1-4.334a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.478 5.867c-.314 1.178-.314 2.825-.314 5.256V21.79c0 2.43 0 4.078.314 5.255l-.314-.024c-1.3-.128-2.175-.416-2.828-1.07-1.172-1.171-1.172-3.057-1.172-6.828V13.79c0-3.772 0-5.657 1.172-6.829.653-.653 1.528-.942 2.828-1.07zM25.523 27.045c.314-1.177.314-2.825.314-5.256V11.124c0-2.43 0-4.078-.314-5.256l.314.024c1.3.128 2.175.417 2.829 1.07 1.171 1.172 1.171 3.057 1.171 6.829v5.333c0 3.771 0 5.657-1.171 6.828-.654.654-1.529.942-2.829 1.07z",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }